import { canvasPaint } from "./native-gradient";
import { type RenderContext } from "./canvas-surface";
import { polygonCorners } from "../native/polygon-corners";
import { cornerRadius } from "../native/corners";
import type { SceneNode } from "../scene/model";
import { nodeMatrix } from "../native/transforms";
import { localOutline, strokeRuns } from "../native/stroke";
import { shapeStyle, strokeRadius } from "../native/appearance";

export function paintShape(ctx: RenderContext, node: SceneNode) {
  const m = nodeMatrix(node),
    w = node.geometry.width!,
    h = node.geometry.height!,
    style = shapeStyle(node);
  ctx.save();
  ctx.transform(m[0] / w, m[1] / w, m[2] / h, m[3] / h, m[4], m[5]);
  ctx.beginPath();
  if (node.kind === "polygon" && cornerRadius(node) > 0) {
    polygonCorners(node).forEach((c, i) => {
      if (i === 0) ctx.moveTo(c.entry.x, c.entry.y);
      else ctx.lineTo(c.entry.x, c.entry.y);
      ctx.quadraticCurveTo(c.control.x, c.control.y, c.exit.x, c.exit.y);
    });
    ctx.closePath();
  } else if (cornerRadius(node) > 0)
    ctx.roundRect(-w / 2, -h / 2, w, h, cornerRadius(node));
  else if (node.kind === "ellipse")
    ctx.ellipse(0, 0, w / 2, h / 2, 0, 0, Math.PI * 2);
  else {
    localOutline(node).forEach((p, i) => {
      if (i === 0) ctx.moveTo(p.x, p.y);
      else ctx.lineTo(p.x, p.y);
    });
    ctx.closePath();
  }
  if (style.fillEnabled) {
    ctx.fillStyle = canvasPaint(
      ctx,
      style.fill,
      node.appearance.fillGradient,
      w,
      h,
    );
    ctx.save();
    ctx.globalAlpha *= Number(node.appearance.fillAlpha ?? 1);
    ctx.fill();
    ctx.restore();
  }
  if (strokeRadius(node) > 0) {
    ctx.strokeStyle = canvasPaint(
      ctx,
      style.stroke,
      node.appearance.strokeGradient,
      w,
      h,
    );
    ctx.lineWidth = style.strokeWidth;
    ctx.lineJoin = "round";
    if (style.lineStyle !== "solid") {
      ctx.beginPath();
      ctx.lineCap = style.lineStyle === "dotted" ? "round" : "butt";
      for (const run of strokeRuns(node)) {
        run.points.forEach((p, i) => {
          if (!i) ctx.moveTo(p.x, p.y);
          else ctx.lineTo(p.x, p.y);
        });
        if (run.closed) ctx.closePath();
      }
    }
    ctx.save();
    ctx.globalAlpha *= Number(node.appearance.strokeAlpha ?? 1);
    ctx.stroke();
    ctx.restore();
  }
  ctx.restore();
}
